import { themedStyled } from 'common/styles/styletron.theme';
import { Input } from 'components/elements';
import { CustomLabel } from 'components/elements/custom-form-control';
import { Container, SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

export default function CostField() {
  const { t } = useTranslation();
  return (
    <Container $style={{ height: 'auto' }}>
      <OtherContainer>
        <CustomLabel label={t('common:discount')} />
        <Input
          type="number"
          name="discount"
          placeholder={t('common:discount')}
          textAlign="right"
          clearable={false}
          defaultValue={0}
          noMargin
        />
      </OtherContainer>
      <SeparatorVertical $margin={16} />
      <OtherContainer>
        <CustomLabel label={t('common:other')} />
        <Input
          type="number"
          name="otherCost"
          defaultValue={0}
          placeholder={t('common:other')}
          textAlign="right"
          clearable={false}
          noMargin
        />
      </OtherContainer>
    </Container>
  );
}

export const OtherContainer = themedStyled('div', {
  display: 'flex',
  justifyContent: 'space-between',
});
